/**
 * @generated SignedSource<<6ed67229740683c919ccd37bddc19d02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsRowTags$data = {
  readonly label: string;
  readonly subTitle: string | null;
  readonly tags: ReadonlyArray<{
    readonly color: string;
    readonly label: string;
  } | null> | null;
  readonly " $fragmentType": "ProductDetailsRowTags";
};
export type ProductDetailsRowTags$key = {
  readonly " $data"?: ProductDetailsRowTags$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowTags">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsRowTags",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductInfoComponentTagsRowTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentTagsRow",
  "abstractKey": null
};
})();

(node as any).hash = "458d863462d5e786da4d60fb9fcd8598";

export default node;
